/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Weightedaverage1Inputs */

const he_item_stats_weightedaverage1 = /** @type {(inputs: Item_Stats_Weightedaverage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ממוצע משוקלל`)
};

const en_item_stats_weightedaverage1 = /** @type {(inputs: Item_Stats_Weightedaverage1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time-weighted`)
};

/**
* | output |
* | --- |
* | "Time-weighted" |
*
* @param {Item_Stats_Weightedaverage1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_weightedaverage1 = /** @type {((inputs?: Item_Stats_Weightedaverage1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Weightedaverage1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_weightedaverage1(inputs)
	return en_item_stats_weightedaverage1(inputs)
});
export { item_stats_weightedaverage1 as "item_stats_weightedAverage" }